import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ConnectedPanelHeader from "@/components/feed/driver-centric/ConnectedPanelHeader";
import type { Feed } from "@/store/types";
import { zinc } from "@/ui/tokens";

export default function FeedHeader({ feed }: { feed: Feed }) {
  return (
    <ConnectedPanelHeader>
      <Box sx={{ pl: 1 }}>
        <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, mb: "-4px" }}>{feed.title}</Typography>
        <Typography sx={{ fontSize: "0.875rem", color: zinc[300] }}>
          {feed?.isPrivate && "private"}
          {feed?.readOnly && "read only"}
          {feed?.isSilent && "hands free off"}
        </Typography>
      </Box>
    </ConnectedPanelHeader>
  );
}
